export default {
      id: "simple-pause-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#simple-pause-usage",
      toString: function () {
        return this.url;
      }
    }